/* @flow */

import { getPlatformURL } from 'src/shared/app/base/settings/appSettings';
import { useStore } from 'react-redux';

export default function usePlatformURL(): string {
  return getPlatformURL(useStore().getState());
}
